
export default {
  data() {
    return {
      dialog: false,
    }
  },

  methods: {
    aceitoTermos() {
      this.dialog = false
      this.$emit('action-aceito-termos')
    },
  },
}
